import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "audience-access-modal" */'./ContentAccessControlPanel').then(mod => mod.default),
  LoadingComponent: () => null
});